import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography, TextField, Alert, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ModuleHub from '../components/ModuleHub';
import { getAccountingSettings, updateAccountingSettings } from '../../../services/api';

const CompanySettingsPage = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getAccountingSettings(); setSettings(r.data || {}); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  const handleSave = async () => {
    try { await updateAccountingSettings(settings); setSaved(true); setTimeout(() => setSaved(false), 3000); }
    catch (err) { setError(err.message); }
  };

  return (
    <ModuleHub moduleId="system-admin" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" onClick={handleSave}>Save Settings</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {saved && <Alert severity="success" sx={{ mb: 2 }}>Settings saved successfully</Alert>}
      {loading ? <CircularProgress /> : (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" gutterBottom>Company Profile</Typography>
              <TextField fullWidth label="Company Name" sx={{ mb: 2 }} value={settings.company_name || ''} onChange={(e) => setSettings({ ...settings, company_name: e.target.value })} />
              <TextField fullWidth type="number" label="Fiscal Year Start Month (1-12)" value={settings.fiscal_year_start || 1} onChange={(e) => setSettings({ ...settings, fiscal_year_start: parseInt(e.target.value) })} />
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card><CardContent>
              <Typography variant="h6" gutterBottom>Security Policies</Typography>
              <TextField fullWidth type="number" label="Password Min Length" sx={{ mb: 2 }} value={settings.password_min_length || 8} onChange={(e) => setSettings({ ...settings, password_min_length: parseInt(e.target.value) })} />
              <TextField fullWidth type="number" label="Session Timeout (minutes)" sx={{ mb: 2 }} value={settings.session_timeout_minutes || 30} onChange={(e) => setSettings({ ...settings, session_timeout_minutes: parseInt(e.target.value) })} />
              <TextField fullWidth type="number" label="Max Login Attempts" value={settings.max_login_attempts || 5} onChange={(e) => setSettings({ ...settings, max_login_attempts: parseInt(e.target.value) })} />
            </CardContent></Card>
          </Grid>
          <Grid item xs={12}>
            <Card><CardContent>
              <Typography variant="h6" gutterBottom>Quick Links</Typography>
              <Button sx={{ mr: 1 }} onClick={() => navigate('/settings')}>ERP Settings</Button>
              <Button sx={{ mr: 1 }} onClick={() => navigate('/users')}>User Management</Button>
              <Button onClick={() => navigate('/accounting/user-access')}>Access Control</Button>
            </CardContent></Card>
          </Grid>
        </Grid>
      )}
    </ModuleHub>
  );
};

export default CompanySettingsPage;
